// Meta description (e og/twitter:description) de post de blog e artigo de
// coluna. Sem descrição cadastrada, a página passava "" ao template param e o
// HTML saía com content="true" (~1.800 URLs em 08/10). Aqui a descrição cai
// para um trecho do texto e, sem texto, para a reserva: nunca volta vazia.
//
// Sem imports: roda no Nuxt e no node:test.

const LIMITE_DESCRICAO = 155;
const DESCRICAO_PADRAO = "Bella da Semana";

const ENTIDADES: Record<string, string> = {
  nbsp: " ",
  amp: "&",
  quot: '"',
  apos: "'",
  lt: "<",
  gt: ">",
  hellip: "…",
  ndash: "–",
  mdash: "—",
  lsquo: "‘",
  rsquo: "’",
  ldquo: "“",
  rdquo: "”",
  laquo: "«",
  raquo: "»",
  ordm: "º",
  ordf: "ª",
  deg: "°",
};

// Acentos que o editor antigo grava como entidade (&ccedil;, &atilde;, &Eacute;...)
const ACENTOS: Record<string, string> = {
  acute: "́",
  grave: "̀",
  circ: "̂",
  tilde: "̃",
  uml: "̈",
  cedil: "̧",
};

function decodificarEntidade(entidade: string, nome: string): string {
  if (nome[0] === "#") {
    const hexa = nome[1] === "x" || nome[1] === "X";
    const codigo = parseInt(nome.slice(hexa ? 2 : 1), hexa ? 16 : 10);
    return codigo > 0 && codigo <= 0x10ffff ? String.fromCodePoint(codigo) : entidade;
  }
  if (nome in ENTIDADES) return ENTIDADES[nome];
  const acento = /^([a-zA-Z])(acute|grave|circ|tilde|uml|cedil)$/.exec(nome);
  if (acento) return (acento[1] + ACENTOS[acento[2]]).normalize("NFC");
  return entidade;
}

/** Texto corrido do HTML do post: sem tags, com as entidades decodificadas. */
export function textoDoHtml(html: unknown): string {
  if (typeof html !== "string") return "";
  return html
    .replace(/<(script|style)\b[\s\S]*?<\/\1\s*>/gi, " ")
    .replace(/<[^>]*>/g, " ")
    .replace(/&(#x[0-9a-f]+|#\d+|[a-z]+);/gi, decodificarEntidade)
    .replace(/\s+/g, " ")
    .trim();
}

/** Corta no limite de palavra, com reticências, quando passa do limite. */
function cortar(texto: string, limite: number): string {
  if (texto.length <= limite) return texto;
  const corte = texto.slice(0, limite - 1);
  const ultimoEspaco = corte.lastIndexOf(" ");
  const base = ultimoEspaco > limite / 2 ? corte.slice(0, ultimoEspaco) : corte;
  return base.replace(/[\s,;:.–—-]+$/, "") + "…";
}

/**
 * `metaDescription` é o `meta_description` da API (`[{ content }]`) ou uma
 * string. Ordem: descrição cadastrada; trecho do `html` (até 155 caracteres);
 * `reserva`.
 */
export function descricaoDaPagina(
  metaDescription: unknown,
  html: unknown,
  reserva: string,
): string {
  const cadastrada = Array.isArray(metaDescription)
    ? (metaDescription[0] as { content?: unknown } | undefined)?.content
    : metaDescription;
  if (typeof cadastrada === "string" && cadastrada.trim()) return cadastrada.trim();

  const texto = textoDoHtml(html);
  if (texto) return cortar(texto, LIMITE_DESCRICAO);

  return reserva.trim() || DESCRICAO_PADRAO;
}
